import { authorizedInstance } from "../config/axios"

export const getVideoLogs = async (filters) => {
  const params = new URLSearchParams(
    Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== undefined && v !== "")
    )
  )
  const response = await authorizedInstance.get(`/report-videos-log/?${params}`)
  return response.data
}

export const getVideoLogById = async (reportId) => {
  const response = await authorizedInstance.get(
    `/report-videos-log/${reportId}`
  )
  return response.data
}
